module.exports = __webpack_public_path__ + "img/institucionalcnaazul.de07d233.png";